import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Config, Config_General, FullConfig, InitialConfig, SysIAccionesMonitoreo, SysIAnalitosResulTipoListas } from '../../types/types.config';
import { User } from '../../types/types.user';
// Define the initial state using that type
const initialState: InitialConfig = {
  Loading: true,
  IsAuthenticated: false,
  FullConfigLoaded: false,
  Error: null,
  Data: null,
  HeightPanels: 190,
  IsEditing: false,
  LstAnalitosResulTipoListas: [],
  LstAccionesMonitoreo: [],
  LstUsuarios: [],
  ModalBarcodePrintersVisible: false,
  apiUrl: null,
  signalRUrl: null,
};

export const configSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    set: (state) => {},
    setLoadingCnf: (state, action: PayloadAction<boolean>) => {
      state.Loading = action.payload;
    },
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.IsAuthenticated = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.Error = action.payload;
      state.Data = null;
      state.Loading = false;
    },
    get: (state, action: PayloadAction<InitialConfig>) => {
      // Preservar apiUrl/signalRUrl: getConfig() envía un payload con estos
      // valores en null, lo que borraría las URLs cargadas por setApiUrls.
      return { ...action.payload, apiUrl: state.apiUrl, signalRUrl: state.signalRUrl };
    },
    // Fusiona el payload de GetAllConfig sobre el Config_General ya cargado por
    // el endpoint público. No usar `get` aquí: ese reducer reemplaza el estado.
    setFullConfig: (state, action: PayloadAction<FullConfig>) => {
      state.Data = { ...(state.Data ?? ({ Config_General: [] } as Config)), ...action.payload };
      state.FullConfigLoaded = true;
    },
    clearFullConfig: (state) => {
      state.FullConfigLoaded = false;
    },
    // Reemplaza SOLO el nodo Config_General con datos frescos del servidor,
    // sin tocar el resto de Data. Se usa tras recargar/guardar la configuración
    // general para que el store persistido no quede desfasado.
    setConfigGeneral: (state, action: PayloadAction<Config_General[]>) => {
      state.Data = { ...(state.Data ?? ({ Config_General: [] } as Config)), Config_General: action.payload };
    },
    setHeightPanels: (state, action: PayloadAction<number>) => {
      state.HeightPanels = action.payload;
    },
    setEditingMode: (state, action: PayloadAction<boolean>) => {
      state.IsEditing = action.payload;
    },
    setLstAnalitosResulTipoListas: (state, action: PayloadAction<SysIAnalitosResulTipoListas[]>) => {
      state.LstAnalitosResulTipoListas = action.payload;
    },
    setLstAccionesMonitoreo: (state, action: PayloadAction<SysIAccionesMonitoreo[]>) => {
      state.LstAccionesMonitoreo = action.payload;
    },
    setLstUsuarios: (state, action: PayloadAction<User[]>) => {
      state.LstUsuarios = action.payload;
    },
    setModalBarcodePrintersVisible: (state, action: PayloadAction<boolean>) => {
      state.ModalBarcodePrintersVisible = action.payload;
    },
    setApiUrls: (state, action: PayloadAction<{ apiUrl: string; signalRUrl: string }>) => {
      state.apiUrl = action.payload.apiUrl;
      state.signalRUrl = action.payload.signalRUrl;
    },
  },
});

export const { set, setError, get, setFullConfig, clearFullConfig, setConfigGeneral, setIsAuthenticated, setLoadingCnf, setHeightPanels, setEditingMode, setLstAnalitosResulTipoListas, setLstAccionesMonitoreo, setLstUsuarios, setModalBarcodePrintersVisible, setApiUrls } = configSlice.actions;
